<template>
  <div>
    <ClientOnly>
      <component :is="typeIcon" v-if="typeIcon" class="w-full h-full" />
      <template #fallback>
        <div class="w-full h-full bg-shade-200 animate-pulse"></div>
      </template>
    </ClientOnly>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { iconForType } from '~/const/resource'

const props = defineProps({
  type: {
    type: String as PropType<IconType>,
    required: true,
  },
})

// Type icon
const typeIconPath = computed<string>(() => {
  if (!iconForType.has(props.type)) return 'technical/None'
  return iconForType.get(props.type)
})

const glob = import.meta.glob('~/assets/icon/**/*', {
  eager: true,
})
const typeIcon = computed<typeof defineAsyncComponent>(() => {
  const folder = typeIconPath.value.split('/')[0]
  const icon = typeIconPath.value.split('/')[1]
  return glob['/assets/icon/' + folder + '/' + icon + '.svg']
})
</script>
